module.exports = __webpack_public_path__ + "public/img/电子巡更.ccf2a937.png";